import { sizeTab, texto, a11yProps } from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import SolicitudPedidosUsuariosRechazadosPagina from "./solicitudes-pedidos-usuarios-rechazadas/solicitudesPedidosUsuariosRechazadasPage";
import SolicitudPedidosUsuariosEnesperaPagina from "./solicitudes-pedidos-usuarios-en-espera/SolicitudPedidosUsuariosEnesperaPagina";
import SolicitudPedidosUsuariosAprobadasPagina from "./solicitudes-pedidos-usuarios-aprobadas/solicitudesPedidosUsuariosAprobadas";
import SolicitudPedidosUsuariosfinalizadosPagina from "./solicitudes-pedidos-usuarios-finalizados/solicitudes-pedidos-usuarios-finalizados";

export default function SolicitudUsuariosPedidosPagina() {
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"Revisión de Solicitud de Pedido"}>
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs solicitud pedidos"
        >
          <Tab label={texto.solicitud_pedido_espera} {...a11yProps(0)} />
          <Tab label={texto.solicitudes_pedido_aprobadas}{...a11yProps(1)} />
          <Tab label={texto.solicitud_pedido_rechazada} {...a11yProps(2)} />
          <Tab label={texto.solicitud_pedido_finalizada}{...a11yProps(3)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <SolicitudPedidosUsuariosEnesperaPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <SolicitudPedidosUsuariosAprobadasPagina />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <SolicitudPedidosUsuariosRechazadosPagina />
      </CustomTabPanel>
       <CustomTabPanel value={valueTab} index={3}>
        <SolicitudPedidosUsuariosfinalizadosPagina />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}
